import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { NotificationsSidebarContainer } from './NotificationsSidebarContainer'

export const NotificationsSidebarHostContainer = observer(
  function NotificationsSidebarHostContainer() {
    const { notifications } = useFeatures((r) => ({
      notifications: r.notifications.internal(),
    }))
    return (
      <NotificationsSidebarContainer
        vm={notifications.notificationsSidebarVm}
      />
    )
  },
)
